import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { SingleSelectFilterPicker } from 'seagull';
import { DateFilterPickerPresets } from './DateFilterPicker.types';
export function DateFilterPicker(props) {
    const { value, onChange } = props;
    const datesPresets = useMemo(()=>[
            {
                label: 'All time',
                value: DateFilterPickerPresets.AllTime
            },
            {
                label: 'Today',
                value: DateFilterPickerPresets.Today
            },
            {
                label: 'This week',
                value: DateFilterPickerPresets.ThisWeek
            },
            {
                label: 'This month',
                value: DateFilterPickerPresets.ThisMonth
            },
            {
                label: 'Previous month',
                value: DateFilterPickerPresets.PreviousMonth
            },
            {
                label: 'Last 3 months',
                value: DateFilterPickerPresets.LastThreeMonths
            }
        ], []);
    return /*#__PURE__*/ _jsx(SingleSelectFilterPicker, {
        value: value,
        testId: 'date-filter-picker',
        options: datesPresets,
        label: "Invoice issue date",
        onChange: (option)=>option ? onChange(option.value) : null
    });
}
